<ng-template #businessUploadModal let-modal>
  <div *ngIf="isSuccess">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Batch Business Upload</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal(true)"
              title="Close Modal"></button>
    </div>

    <div class="modal-body" [style.max-height.px]="modalHeight">
      <div class="d-flex">
        <div class="col-sm-9">
          <div class="file-upload-container">
            <label for="fileInput">FILE</label>
            <div class="file-input-wrapper">
              <input type="text"
                     [value]="fileName"
                     class="cursor-pointer"
                     readonly
                     (click)="fileInput.click()" />

              <button type="button" (click)="fileInput.click()" class="icon-button">
                <img src="../assets/images/file-upload-icon.svg" alt="Add Icon" class="add-icon" />
              </button>
            </div>
            <input type="file"
                   #fileInput
                   (change)="onFileSelected($event)"
                   class="d-none" />
          </div>
        </div>
        <div class="col-sm-3 csv-example-section" (click)="downloadCSVExample();">
          <img src="../assets/images/csv-file-icon.svg" alt="Add Icon" class="add-icon csv-example-icon" />
          <span class="csv-example ms-1">CSV EXAMPLE</span>
        </div>
      </div>

      <input type="file"
             multiple
             #imageInput
             accept="image/*"
             class="d-none"
             (change)="onImagesSelected($event);" />

      <div class="img-section" (click)="images.length == 0 ? imageInput.click() : false">
        <label for="IMAGES">IMAGES</label>
        <div class="image-section" [ngClass]="{'d-flex justify-content-center':images.length <= 0}" [style.min-height.px]="modalHeight - 200" [style.max-height.px]="modalHeight - 230">
          <div class="row">
            <div *ngIf="images.length <= 0" class="d-flex align-items-center text-muted">
              Please click here to upload your photos
            </div>
            <div class="col-sm-6" *ngFor="let img of images; let i = index">
              <div class="image-preview d-flex justify-content-between mt-2" *ngIf="img.preview">
                <div class="d-flex flex-shrink">
                  <img [src]="img.preview" class="rounded" />
                  <div class="fw-bold fs-5 ms-2">{{img.file?.name}}</div>
                </div>
                <button class="btn btn-primary remove-btn me-3" (click)="removeImage(i, $event)">Remove</button>
              </div>
            </div>
          </div>
          <div *ngIf="images.length > 0" class="image-preview">
            <label for="ADD IMAGES" class="cursor-pointer" (click)="imageInput.click()">ADD IMAGES</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer content-end me-4">
      <!--<a class="btn btn-link last-prod" (click)="failedCSVList()" *ngIf="uploadDataResponse?.csvUploadProgress == 2">
        <img src="../assets/images/csv-file-icon.svg" alt="Add Icon" class="add-icon csv-example-icon" />
        <span class="ms-2">Download Error Files</span>
      </a>-->
      <button class="btn btn-primary" (click)="uploadData()">Upload Business</button>
    </div>
  </div>

  <div *ngIf="!isSuccess">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Upload Error</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal()"
              title="Close Modal"></button>
    </div>
    <div class="modal-body body-padding" [style.height.px]="modalHeight">
      <div class="mt-3" *ngIf="uploadDataResponse.imageUploadProgress == 2">
        <div class="fw-bold">Your Image files contains a few issues</div>
        <div class="card mt-1">
          <div class="card-body" [style.height.px]="imageErrorContentHeight">
            <div>
              <div *ngIf="uploadDataResponse.imageResponse.businessNotFoundForImages != null">
                <div class="fw-bold">Business Not Found For Images</div>
                <div> {{uploadDataResponse.imageResponse.businessNotFoundForImages}} </div>
              </div>
              <div *ngIf="uploadDataResponse.imageResponse.typeNotFoundForImages != null" class="mt-1">
                <div class="fw-bold">Image Type Not Found For Images</div>
                <div> {{uploadDataResponse.imageResponse.typeNotFoundForImages}} </div>
              </div>
              <div *ngIf="uploadDataResponse.imageResponse.invalidImageName != null" class="mt-1">
                <div class="fw-bold">Invalid Images Name</div>
                <div> {{uploadDataResponse.imageResponse.invalidImageName}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer content-end">
      <a class="btn btn-link last-prod" (click)="failedCSVList()" *ngIf="uploadDataResponse?.csvUploadProgress == 2">
        <img src="../assets/images/csv-file-icon.svg" alt="Add Icon" class="add-icon csv-example-icon" />
        <span class="ms-2">Download Error Files</span>
      </a>
      <button class="btn btn-primary" (click)="reUpload()">Retry Upload</button>
    </div>
  </div>
</ng-template>
